import { keyframes } from "styled-components";

export const fadein = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;
